import http from 'hub-http/clients/apiClient';
export default class HttpAdapterConfig {
  getFetcher() {
    return http.get;
  }
}